<div class="vid-card vid-card-initial d-flex flex-column justify-content-center align-items-center">
  <div class="d-flex justify-content-center align-items-center flex-column">
    <div class="d-flex justify-content-center align-items-center flex-column">
      <h3>Error</h3>
      <p class="vid-small-label">{{ errorService.errorKey | translate }}</p>

      <div *ngIf="errorService.errorCode === 403" class="mt-3">
        <button id="logoutBtnError" (click)="onLogout()" type="button"
                class="float-end vid-btn vid-btn-orange vid-btn-sm ms-2 logout-btn">{{ 'IDENTITY.LOGOUT' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
